import { useQuery } from '@tanstack/react-query';
import { rpcClient } from 'src/api/rpc/client';

const QUERY_KEY_BASE = 'core-documents';

export function useListDocumentsForPicker(input?: {
  query?: string;
  limit?: number;
}) {
  return useQuery({
    queryKey: [QUERY_KEY_BASE, 'list-for-picker', input],
    queryFn: () => rpcClient.core.documents.listForPicker(input ?? {}),
  });
}

export function useDocumentPreview(documentId: string | null) {
  return useQuery({
    queryKey: [QUERY_KEY_BASE, 'preview', documentId],
    queryFn: () =>
      rpcClient.core.documents.getPreview({ documentId: documentId ?? '' }),
    enabled: !!documentId,
  });
}

export function useDocumentOcrResultPreview(ocrResultId: string | null) {
  return useQuery({
    queryKey: [QUERY_KEY_BASE, 'ocr-preview', ocrResultId],
    queryFn: () =>
      rpcClient.core.documents.getOcrResultPreview({
        ocrResultId: ocrResultId ?? '',
      }),
    enabled: !!ocrResultId,
  });
}

export function useDocumentOcrResultContent(
  ocrResultId: string | null,
  enabled = true,
) {
  return useQuery({
    queryKey: [QUERY_KEY_BASE, 'ocr-content', ocrResultId],
    queryFn: () =>
      rpcClient.core.documents.getOcrResultContent({
        ocrResultId: ocrResultId ?? '',
      }),
    enabled: enabled && !!ocrResultId,
  });
}
